import type {
  RyftPaymentInitiateRequestType,
  RyftPaymentInitiateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useRyftManagementCheckoutPaymentInitiate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({ data }: { data: RyftPaymentInitiateRequestType }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "ryft-management/checkout/payment-sessions",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftPaymentInitiateResponseType>(response).data,
      ),
  });
};
